import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ESkeletonType } from '@norfolk-southern/accessns-components';
import { AgGridAngular } from 'ag-grid-angular';

import { NSGuaranteesConstants } from '@ruby/configs/guarantees.constants';
import { IContact } from '@ruby/modules/account/models/contact.interface';
import { ICustomer } from '@ruby/modules/customer-select/models/customer.interface';
import {
  IGuaranteesConfirmation,
  IGuarantee
} from '@ruby/shared/models/guarantees/guarantees.interface';

@Component({
  selector: 'ng-guarantees-lift-dialog',
  templateUrl: './guarantee-lift.dialog.html',
  styleUrls: ['./guarantee-lift.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GuaranteeLiftDialog implements OnInit {
  @Input() customer?: ICustomer;
  @Input() guarantee!: IGuarantee;
  @Input() userInfo?: IContact;
  @Output() confirmGuarantee: EventEmitter<IGuaranteesConfirmation> = new EventEmitter<IGuaranteesConfirmation>();
  form!: UntypedFormGroup;
  title!: string;
  guaranteeDays!: number;
  grid!: AgGridAngular;
  skeletonType: ESkeletonType = ESkeletonType.GRID;
  maxReferenceNumberLimit = 30;

  constructor() { }

  ngOnInit(): void {
    this.title = NSGuaranteesConstants.confirmationTitle.lift;
    this.form = new UntypedFormGroup({
      email: new UntypedFormControl(this.userInfo?.email, [Validators.required, Validators.email]),
      reference: new UntypedFormControl('', Validators.required),
      location: new UntypedFormControl('', Validators.required)
    });
  }

  /**
   * Set Grid
   *
   * @summary Set grid
   * @param $grid: AgGridAngular
   * @returns void
   */
  setGrid($grid: AgGridAngular): void {
    this.grid = $grid;
  }

  /**
   * Emit Confirm Guarantee Submit
   *
   * @summary Emits Confirm Guarantee Event with the right payload
   * @returns void
   */
  submit(): void {
    const payload: IGuaranteesConfirmation = {
      chargeType: 'L',
      corporateCustomerName: `${ this.customer!.customerName }`,
      email: this.form.get('email')!.value,
      equipment: this.guarantee.equipmentId,
      equipmentType: this.guarantee.type,
      guaranteeAmount: this.guarantee.storageAmount || '0.00',
      referenceNumber: this.form.get('reference')!.value,
      terminalName: this.form.get('location')!.value,
      waybillSerialNumber: this.guarantee.waybillSerialNumber
    };
    this.confirmGuarantee.emit(payload);
  }
}
